<mat-nav-list>
  <!-- [routerLink]="['/dashboard/souscription', option.productName]" -->
  @for (option of menus.items; track option) {
    <a mat-list-item (click)="openLink($event, option)">
      <span matListItemTitle>{{ option.label }}</span>
    </a>
  }
</mat-nav-list>
